module.exports = __webpack_public_path__ + "static/assets/749e41931a474a1320cf2b153789c67c.gif";